<template>
  <div class="help-search">
    <div class="title">我们将尽可能为您提供帮助</div>
    <form @submit="onSubmit">
      <div class="search-input">
        <div class="search-input_search-icon" @click="onSearch"></div>
        <input type="text" v-model="keyword" placeholder="DG.hire是什么？" />
        <div class="search-input_clear-icon" v-show="!!keyword" @click="onClearClick"></div>
      </div>
    </form>
    <div class="subtitle">有问题吗？我们有答案。除此之外，我们还免费提供任何海外雇佣相关的咨询服务。<a @click="onConsultClick">立即咨询 ></a></div>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  keyword: String
});
const keyword = ref(props.keyword);

const emits = defineEmits(['search', 'clear']);
function onSearch() {
  if (!keyword.value) {
    return;
  }
  emits('search', keyword.value);
}

function onSubmit(e: Event) {
  e.preventDefault();
  onSearch();
}

function onClearClick() {
  keyword.value = '';
  emits('clear');
}
function onConsultClick() {
  useLeadsInfo('搜索框-立即咨询', 'serviceConsulting');
}
</script>
<style lang="less" scoped>
.help-search {
  background: url("https://video.reta-inc.com/image/default/4588F73DCC244D4384ADF10A49108016-6-2.jpg") no-repeat;
  background-position: center;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    font-weight: 600;
    font-size: 36px;
    line-height: 50px;
    margin-top: 64px;
    color: #1D2129;
  }

  .search-input {
    margin-top: 20px;
    width: 700px;
    height: 60px;
    font-size: 20px;
    line-height: 22px;
    border-radius: 8px;
    background: #fff;
    position: relative;
    padding-left: 60px;
    box-sizing: border-box;

    &_search-icon {
      position: absolute;
      width: 24px;
      height: 24px;
      background: url("@/assets/icons/search.svg") no-repeat;
      top: 18px;
      left: 20px;
      cursor: pointer;
    }

    &_clear-icon {
      position: absolute;
      width: 24px;
      height: 24px;
      background: url("@/assets/icons/close.svg") no-repeat;
      top: 18px;
      right: 24px;
      cursor: pointer;
    }

    input {
      display: block;
      height: 100%;
      width: 580px;
      box-sizing: border-box;
      color: #1D2129;

      &,
      &:hover,
      &:focus,
      &:active {
        border: 0;
        outline: none;
      }
    }
  }

  .subtitle {
    margin-top: 20px;
    font-size: 16px;
    line-height: 22px;
    color: #4E5969;
    opacity: 0.8;

    a {
      color: #165DFF;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 800px) {
  .help-search {
    height: 200px;
    padding: 0 20px;
    .title {
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      margin-top: 36px;
    }

    form {
      width: 100%;
      margin-top: 12px;
    }

    .search-input {
      height: 40px;
      margin: 0;
      border-radius: 8px;
      width: auto;
      padding-left: 38px;
      padding-right: 40px;
      &, & > input {
        font-size: 14px;
        line-height: 22px;
      }

      input {
        width: 100%;
      }

      &_search-icon {
        width: 16px;
        height: 16px;
        top: 13px;
        left: 11px;
        background-size: contain;
      }

      &_clear-icon {
        width: 18px;
        height: 18px;
        top: 11px;
        right: 11px;
        background-size: contain;
      }
    }

    .subtitle {
      width: 300px;
      text-align: center;
      font-size: 12px;
      line-height: 18px;
    }
  }
}
</style>
